import { defineMessages } from 'react-intl-next';

export default defineMessages({
    backButtonText: {
        defaultMessage: 'Back',
        description: 'Back button text',
        id: 'sd.common.back-button.text',
    },
});
